const t = ["auto", "top", "right", "bottom", "left"];
export {
  t as default
};
